import { useContext, useEffect, useState } from 'react';
import { ControlPopupContainer, ControlPopupContent } from './styles';
import { PopupMenu, PopupMenuItem } from './styles';
import { SelectionRange } from '../../EditablePage/EditableBlock';
import { INITIAL_CONTROLS, useStore } from '../../../../store';
import { TrashSimple, X } from '@phosphor-icons/react';
import { TtsContext } from '../../../../contexts/TtsContext';
import { useTranslation } from 'react-i18next';

interface SpeedPopupProps {
  blockId: string;
  selection?: SelectionRange | undefined;
  selectionId?: string;
}

export const SpeedPopup = ({
  blockId,
  selection,
  selectionId,
}: SpeedPopupProps) => {
  const {
    updateBlockControl,
    createEffectSelection,
    removeEffectFromSelection,
    blocks,
  } = useStore();
  const { hideToolbox } = useContext(TtsContext);

  const { t } = useTranslation('myapps');

  const [currentValue, setCurrentValue] = useState<string>();

  const index = blocks.findIndex((b) => b.id === blockId);

  useEffect(() => {
    if (selectionId) {
      const value = blocks[index]?.selections
        ?.find((selection) => selection.id === selectionId)
        ?.controls.find((c) => c.control === 'speed')?.value as
        | string
        | undefined;

      setCurrentValue(value ?? 'default');
    } else {
      selection
        ? setCurrentValue('default')
        : setCurrentValue(blocks[index]?.controls?.speed);
    }
  }, [blocks, index, selection, selectionId]);

  const handleChange = (selectedOption: string) => {
    if (selection) {
      if (selectedOption === 'default' && selectionId) {
        removeEffectFromSelection(blockId, selectionId, 'speed');
      } else {
        createEffectSelection(
          blockId,
          selection.start,
          selection.end,
          'speed',
          selectedOption
        );
      }
    } else {
      if (blocks[index] && blocks[index].controls.speed !== selectedOption) {
        updateBlockControl(blockId, 'speed', selectedOption);
      }
    }
    hideToolbox();
  };

  const options = [
    { value: 'default', label: t('TTS_EFFECT_OPTION_DEFAULT') },
    { value: 'x-slow', label: t('TTS_EFFECT_OPTION_X_SLOW') },
    { value: 'slow', label: t('TTS_EFFECT_OPTION_SLOW') },
    { value: 'medium', label: t('TTS_EFFECT_OPTION_MEDIUM') },
    { value: 'fast', label: t('TTS_EFFECT_OPTION_FAST') },
    { value: 'x-fast', label: t('TTS_EFFECT_OPTION_X_FAST') },
  ];

  return (
    <ControlPopupContainer>
      <ControlPopupContent>
        <PopupMenu>
          {options.map((option) => (
            <PopupMenuItem
              isSelected={currentValue === option.value}
              key={crypto.randomUUID() + `speed-options-` + option.value}
              onClick={() => handleChange(option.value)}
            >
              {option.label}
            </PopupMenuItem>
          ))}
        </PopupMenu>
      </ControlPopupContent>
      {currentValue !== 'default' && (
        <PopupMenuItem
          isSelected={false}
          onClick={() => handleChange({ ...INITIAL_CONTROLS }.speed)}
          style={{ border: '1px solid #fd6262' }}
        >
          <X />
          Clear
        </PopupMenuItem>
      )}
    </ControlPopupContainer>
  );
};
